import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "TechAI Fortune";
const DEFAULT_DESC = "TechAI Fortune is a U.S. technology consulting and workforce solutions company delivering AI, cloud, data, automation, software and staffing outcomes.";

function upsert(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

export function Seo({ title, description = DEFAULT_DESC, image = "/logo.png", schema }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Technology That Turns Intelligence Into Business Outcomes`;
    const url = `${window.location.origin}${pathname}`;
    document.title = fullTitle;
    upsert('meta[name="description"]', { name: "description", content: description });
    upsert('link[rel="canonical"]', { rel: "canonical", href: url });
    upsert('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsert('meta[property="og:description"]', { property: "og:description", content: description });
    upsert('meta[property="og:url"]', { property: "og:url", content: url });
    upsert('meta[property="og:image"]', { property: "og:image", content: `${window.location.origin}${image}` });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsert('meta[name="twitter:description"]', { name: "twitter:description", content: description });

    let ld = document.getElementById("ld-json-page");
    if (schema) {
      if (!ld) { ld = document.createElement("script"); ld.type = "application/ld+json"; ld.id = "ld-json-page"; document.head.appendChild(ld); }
      ld.textContent = JSON.stringify(schema);
    } else if (ld) ld.remove();
  }, [title, description, image, pathname, schema]);
  return null;
}

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "TechAI Fortune",
  legalName: "TECHAIFORTUNE Inc.",
  url: typeof window !== "undefined" ? window.location.origin : "",
  logo: typeof window !== "undefined" ? `${window.location.origin}/logo.png` : "/logo.png",
  email: "info@techaifortuneinc.com",
  sameAs: ["https://www.linkedin.com/in/techai-fortune-inc-b61230426/"],
  address: { "@type": "PostalAddress", streetAddress: "17350 State Highway 249, Suite 220, #36665", addressLocality: "Houston", addressRegion: "TX", postalCode: "77064", addressCountry: "US" },
};
